// extracted by mini-css-extract-plugin
export default {"container":"PDFHeader_container__op22Y","logo":"PDFHeader_logo__qVywp","title":"PDFHeader_title__WEoQn","header":"PDFHeader_header__kMZzN"};